export default __webpack_public_path__ + "static/media/section-header-3.3cec06ea.jpg";